/**
 * GPS speed-sample sanitization knobs.
 *
 * GPS receivers occasionally drop lock mid-session and report garbage speed
 * for a run of samples (observed on session-143033: 0.0 km/h for 8
 * consecutive samples in the middle of a 106→130 km/h acceleration, implied
 * rates 50–130 m/s²). Such runs defeat the local-median despiker
 * (removeSpeedSpikes, window 5) because the local median is itself
 * corrupted, and then poison every speed consumer: the GPS speed trend, the
 * pitch estimator's de-dynamicization, the accel validator and the sensor
 * frame calibration. The sanitizer rejects samples whose implied
 * acceleration versus the last ACCEPTED sample is beyond physical
 * plausibility and linearly interpolates across the rejected run.
 */

/**
 * Unit: m/s². Maximum plausible |dv/dt| between a sample and the last
 * accepted sample. Empirical anchors (session-143033, 25 Hz RaceBox):
 * strongest GENUINE adjacent-sample rate 16.65 m/s² (≈1.2 g real braking
 * plus doppler noise — note single-sample noise rides on top of the true
 * physical ~1.5 g ceiling, so 15 would clip real braking), glitch samples
 * 50–130 m/s². 20 (≈2 g) rejected exactly the 9 glitch samples and zero
 * genuine ones on that session. Raise only if a device shows genuine rates
 * above 20 (none known); lowering below 17 starts rejecting real braking.
 * Default: 20
 */
export const GPS_SPEED_MAX_PLAUSIBLE_ACCEL_MS2 = 20

/**
 * Unit: seconds. When the last accepted sample is older than this, the next
 * sample is accepted unconditionally (resync). Bounds how long a corrupted
 * (or genuinely discontinuous) stream can be bridged by interpolation — past
 * this horizon the vehicle state is unknown and trusting the receiver again
 * beats extrapolating a stale anchor. Default: 2
 */
export const GPS_SPEED_RESYNC_S = 2
